<nz-header class="section-header">
  {{ "Stroke and Brain Injury" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.fuglMeyerAssessment) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="20"
      [historyItems]="getTemplateItems(20)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.trunkControlTest) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="21"
      [historyItems]="getTemplateItems(21)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.trunkImpairmentScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="22"
      [historyItems]="getTemplateItems(22)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.strokeScoreQuestionnaireMediterrenean) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="3"
      [historyItems]="getTemplateItems(3)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
